import React from 'react';
import PageHeading from '../components/PageHeading';
import { Wrapper } from '../css_global/utils.css';
import ContactUsContent from '../../components_common/ContactUs';
import VerticalSpacer from '../../components_common/VerticalSpacer';

const ContactUs = () => (
  <Wrapper>
    <VerticalSpacer height="40px" />
    <PageHeading text="CONTACT US" />
    <VerticalSpacer height="10px" />
    <ContactUsContent isDesktop />
  </Wrapper>
);

export default ContactUs;
